import { useBasketOneMaterials } from "hooks/useMaterials";
import { MixRead } from "src/store/api/generatedApi";

export const useOverrideMixMaterials = (mix: MixRead) => {
  const materials = useBasketOneMaterials(mix);
  return {
    ratioMaterials: materials.filter((material) => material.unit === "ratio"),
    additions: materials.filter((material) => material.unit !== "ratio"),
  };
};
